<template>
  <el-form>
    <el-divider content-position="left">Impressão etiquetas</el-divider>
    <el-form-item>
      <el-radio v-model="ruleForm.model" label="0">Zebra</el-radio>
      <el-radio v-model="ruleForm.model" label="1">1 por folha</el-radio>
      <el-radio v-model="ruleForm.model" label="2">2 por folha</el-radio>
      <el-radio v-model="ruleForm.model" label="4">4 por folha</el-radio>
    </el-form-item>
    <el-form-item>
      <el-checkbox v-model="ruleForm.warning" autocomplete="off">Imprimir Aviso Recebimento</el-checkbox>
    </el-form-item>
    <el-form-item>
      <el-checkbox v-model="ruleForm.declared" autocomplete="off">Imprimir Declaração Conteudo</el-checkbox>
      <el-radio :disabled="!ruleForm.declared" v-model="ruleForm.type" label="1">Para todas as etiquetas</el-radio>
      <el-radio :disabled="!ruleForm.declared" v-model="ruleForm.type" label="2">Somente que possuem declaração</el-radio>
    </el-form-item>
    <el-divider v-if="proof" content-position="left">Re-impressão de etiquetas</el-divider>
    <div class="bottom clearfix">
      <el-button icon="el-icon-print" type="success" v-if="proof"
        @click="$emit('open')">Tela de Impressão</el-button>
      <el-button icon="el-icon-print" type="info" v-if="proof"
        @click="print(proof, 'comprovante')">Comprovante</el-button>
      <el-button icon="el-icon-print" type="info" v-if="prepost" @click="print(prepost, 'postagem')">Postagem</el-button>
      <el-button icon="el-icon-print" type="info" v-if="motoboy" @click="print(motoboy, 'motoboy')">Motoboy</el-button>
      <el-button icon="el-icon-print" type="info" v-if="external" @click="print(external, 'terceiros')">PLP
        Terceiros</el-button>
    </div>
  </el-form>
</template>
<script>
export default {
  name: "PdvClosedPrint",
  data() {
    return {
      ruleForm: {
        model: '0',
        warning: true,
        declared: true,
        type: '1',
      },
      id: 0,
      proof: null,
      prepost: null,
      external: null,
      motoboy: null,
    }
  },
  methods: {
    clear() {
      this.ruleForm = {
        model: '0',
        warning: true,
        declared: true,
        type: '1',
      };
    },
    setData(id, proof, prepost, external, motoboy) {
      this.id = id;
      this.proof = proof;
      this.prepost = prepost;
      this.external = external;
      this.motoboy = motoboy;
    },
    print(data, name) {
      var downloadLink = document.createElement("a");
      downloadLink.href = data;
      downloadLink.download = `${name}.${this.id}.pdf`;
      downloadLink.click();
    }
  }
}
</script>